import axios from "axios";

// הכתובת של הקונטרולר החדש ב-C#
const API_URL = "https://app.mamadapp.co.il/api/Mmd"; // עדכני לפי הכתובת האמיתית שלך בשרת

class MmdService {
  /**
   * שולח קובץ PDF לשרת לעיבוד ומחזיר את אובייקט התשובה
   * @param file ,האובייקט הפיזי של הקובץ שהמשתמש בחר
   */
  async generateAndProcess(file: File, id: number): Promise<{ success: boolean; downloadUrl?: string; message?: string }> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('jobId', id.toString()); // הכנסה לטופס!

    // ה-URL נשאר נקי בלי סימני שאלה!
    const response = await axios.post(`${API_URL}/generate-and-process`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    return response.data;
  }

  // חדש: שולח קובץ PDF לעיבוד דרך Claude API
  async generateAndProcessClaude(file: File, id: number): Promise<{ success: boolean; downloadUrl?: string; message?: string }> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('jobId', id.toString());

    const response = await axios.post(`https://app.mamadapp.co.il/api/Claude/generate-and-process-claude`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    return response.data;
  }
}

export default new MmdService();